import { Money } from '@rygen/rygen-ui/model';

export class CostEstimateResponse {
  lowestCost?: Money;
  fastestTransit?: Money;

  constructor(opts?: Partial<CostEstimateResponse>) {
    if (opts?.lowestCost) {
      this.lowestCost = new Money(opts.lowestCost);
    }
    if (opts?.fastestTransit) {
      this.fastestTransit = new Money(opts.fastestTransit);
    }
  }
}
